<template>
  <CRow>
    <CCol col="12" xl="12">
      <Spinner v-if="$store.state.loadSpinner" />

      <CCard v-else>
        <CCardHeader>
          <span>الاسئلة </span>
        </CCardHeader>
        <CCardBody>
          <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover mb-5">
              <thead>
                <tr class="table-primary">
                  <th scope="col">#</th>
                  <th scope="col">السؤال</th>
                  <th scope="col">التصنيف</th>
                  <th scope="col">العميل</th>
                  <th scope="col">عدد الاجابات</th>
                  <th scope="col">الحالة</th>
                  <th scope="col">الاجراءات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <th scope="row">{{ item.id }}</th>
                  <td>{{ item.title }}</td>
                  <td>{{ item.category }}</td>
                  <td>{{ item.client }}</td>
                  <td>{{ item.answers_count }}</td>
                  <td>
                    <b :class="`text-${getBadge(item.status)}`">
                      {{ item.status == "1" ? "نشط" : "متوقف" }}
                    </b>
                  </td>
                  <td>
                    <CButton
                      color="info"
                      @click="
                        $router.push({
                          name: 'Question',
                          params: {
                            id: item.id,
                          },
                        })
                      "
                    >
                      <CIcon name="cil-low-vision"></CIcon>
                    </CButton>
                    <CButton class="mx-1" color="warning" @click="openModal(item)">
                      <CIcon name="cil-pencil"></CIcon>
                    </CButton>
                    <CButton
                      class="mx-1"
                      color="danger"
                      @click="deleteItem(item.id)"
                    >
                      <CIcon name="cil-trash"></CIcon>
                    </CButton>
                    <CButton v-if="(item.status == 0)" class="mx-2" color="success" @click="updateStatus(1, item.id)">
                      تفعيل
                    </CButton>
                    <CButton v-else color="danger" class="mx-2" @click="updateStatus(0, item.id)">
                      ايقاف
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <CPagination :active-page.sync="currentPage" :pages="totalPages" />
        </CCardBody>
      </CCard>
    </CCol>
    <edit :form="modalForm" @updateDone="updateDone"></edit>
  </CRow>
</template>

<script>
import Edit from "./Edit";
export default {
  name: "Questions",
  components: {
    Edit,
  },
  data() {
    return {
      items: [],
      activePage: 1,
      currentPage: 1,
      totalPages: 0,
      limit: 10,
      modalForm: null,
    };
  },
  watch: {
    currentPage: {
      handler: function (val, oldVal) {
        this.fetchData(val);
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData(page = 1) {
      this.toggleLoadSpinner();

      this.$http
        .get(`/questions?per_page=15&page=${page}`)
        .then((res) => {
          // handle success
          this.items = res.data.data.data;
          this.totalPages = res.data.data.last_page;
          this.toggleLoadSpinner();
        })
        .catch((error) => {
          //
          this.toggleLoadSpinner();
        });
    },

    toggleLoadSpinner() {
      this.$store.commit("toggleLoadSpinner");
    },

    deactivate(itemId) {
      console.log(itemId);
    },

    getBadge(status) {
      switch (status) {
        case 1:
          return "success";
        case 0:
          return "danger";
        default:
          "primary";
      }
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    openModal(item) {
      this.modalForm = Object.assign({}, item);
      this.update = true;
      this.$store.commit("set", ["showModal", true]);
    },
    deleteItem(id) {
      this.$swal
        .fire({
          title: "تأكيد الحذف",
          text: "هل انت متأكد من الحذف ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "نعم",
          cancelButtonText: "لا",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$http
              .delete("questions/" + id)
              .then((res) => {
                // handle success
                if (res.data.status == 200) {
                  this.fetchData();
                  this.$swal.fire("تم الحذف!", "تم الحذف بنجاح.", "success");
                }
              })
              .catch((error) => {
                // handle error
                console.log(error);
              });
          }
        });
    },
    updateDone() {
      this.fetchData();
    },

    updateStatus(status, id) {
      console.log(status, id);
      this.toggleLoadSpinner();

      this.$http
        .put(`/questions/status/${id}`, { status })
        .then((res) => {
          console.log(res.data);
          const index = this.items.findIndex(object => {
            return object.id === id;
          });
          this.fetchData();
          // Vue.set(this.items, index, res.data.data);
          this.toggleLoadSpinner();
        })
        .catch((error) => {
          // handle error
          this.toggleLoadSpinner();
        });
    }
  },
};
</script>